'use client';
import React from 'react';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiToggleButton from '@new-components/atoms/MuiToggleButton';
import MuiToggleButtonGroup from '@new-components/atoms/MuiToggleButtonGroup';
import MuiTypography from '@new-components/atoms/MuiTypography';
import MuiGrid from '@new-components/atoms/MuiGrid';

type Option = {
  label: string;
  value: string;
};
export type OptionSelectorProps = {
  options: Option[];
  label: string;
  value: string;
  handleChange: (value: string) => void;
};

const CustomOptionSelector = (props: OptionSelectorProps) => {
  const [selectedOption, setSelectedOption] = React.useState<string | null>(
    props.value || null
  );

  const options = React.useMemo(() => {
    return [{label: 'Any', value: 'Any'}, ...props.options];
  }, [props.options]);

  React.useEffect(() => {
    setSelectedOption(props.value || null);
  }, [props.value]);

  const handleChange = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      const newSelection = (event.target as HTMLInputElement).value;
      if (newSelection === 'Any') {
        setSelectedOption(null);
      }
      setSelectedOption(newSelection);
      props.handleChange(newSelection);
    },
    [selectedOption, props.value]
  );

  const selectedValue = () => {
    if (selectedOption === null) {
      return 'Any';
    }
    return selectedOption;
  };

  return (
    <MuiBox>
      <MuiTypography
        sx={{
          height: '24px',
          fontSize: '17px',
          fontWeight: 500,
          letterSpacing: '-0.4px',
          color: '#000000',
          marginBottom: '16px',
        }}>
        {props.label}
      </MuiTypography>
      <MuiToggleButtonGroup value={selectedValue()} onChange={handleChange}>
        <MuiGrid container spacing={1} columns={{xs: 2, sm: 2, md: 3}}>
          {options.map((option) => (
            <MuiGrid item key={option.value}>
              <MuiToggleButton
                value={option.value}
                aria-label={`Select ${option.label}`}
                sx={{
                  'height': '40px',
                  'borderRadius': '100px',
                  'border': '1px solid #82807EB2',
                  'textTransform': 'none',
                  'fontSize': '17px',
                  'fontWeight': 400,
                  'letterSpacing': '-0.4px',
                  'color': '#2D2D2D',
                  'padding': '8px 16px',
                  '&.Mui-selected': {
                    backgroundColor: '#EDECE8',
                  },
                }}>
                {option.label}
              </MuiToggleButton>
            </MuiGrid>
          ))}
        </MuiGrid>
      </MuiToggleButtonGroup>
    </MuiBox>
  );
};

export default CustomOptionSelector;
